import { useQuery } from '@tanstack/react-query';

import { getBulletin, getPublicBulletin } from 'api/v1/requests/bulletins';

export const useBulletin = (id: number) => {
  const numericId = Number.isFinite(id) && id > 0 ? id : 0;
  return useQuery({
    queryKey: ['bulletin', numericId],
    queryFn: () => getBulletin(numericId),
    enabled: numericId > 0,
  });
};

export const useBulletinPublic = (id: number) => {
  const numericId = Number.isFinite(id) && id > 0 ? Math.trunc(id) : 0;
  return useQuery({
    queryKey: ['bulletinPublic', numericId],
    queryFn: () => getPublicBulletin(numericId),
    enabled: numericId > 0,
    retry: false,
    refetchOnWindowFocus: false,
  });
};
